// window.preventAutoCartDrawerOpen = true;
// document.addEventListener("cart:refresh", function (event) {
//   if (window.preventAutoCartDrawerOpen) {
//     event.stopImmediatePropagation();
//   }
// });

// document.addEventListener("DOMContentLoaded", function () {

//   const checkoutModal  = document.getElementById("bulkPackagesCheckoutModal");
//   const loginModal     = document.getElementById("bulkPackagesLoginModal");
//   const registerModal  = document.getElementById("bulkPackagesRegisterModal");

//   const modalTitle = document.getElementById("bulkPackagesModalProductTitle");
//   const modalPrice = document.getElementById("bulkPackagesModalProductPrice");

//   let currentVariant = null;

//   /* ---------------------------------------------------------
//      OPEN CHECKOUT MODAL
//   --------------------------------------------------------- */
//   document.querySelectorAll(".bulk-packages-buy-btn").forEach(btn => {
//     btn.addEventListener("click", function () {
//       const card = this.closest(".bulk-packages-card");

//       currentVariant = card.dataset.variantId;
//       modalTitle.textContent = card.dataset.title;
//       modalPrice.textContent = "$" + card.dataset.price;

//       checkoutModal.classList.add("show");
//     });
//   });

//   /* ---------------------------------------------------------
//      CLOSE ALL MODALS
//   --------------------------------------------------------- */
//   document.querySelectorAll(".bulk-packages-modal-close").forEach(btn => {
//     btn.addEventListener("click", function () {
//       checkoutModal?.classList.remove("show");
//       loginModal?.classList.remove("show");
//       registerModal?.classList.remove("show");
//     });
//   });

//   /* ---------------------------------------------------------
//      OPEN LOGIN FROM CHECKOUT
//      (Store user intent using session storage)
//   --------------------------------------------------------- */
//   const openLoginBtn = document.getElementById("bulkPackagesOpenLoginBtn");
//   if (openLoginBtn) {
//     openLoginBtn.addEventListener("click", function () {

//       // Mark user came from Bulk Packages page
//       sessionStorage.setItem("from_bulk_packages", "1");

//       // Normal modal switch
//       checkoutModal.classList.remove("show");
//       loginModal.classList.add("show");
//     });
//   }

//   /* ---------------------------------------------------------
//      LOGIN BUTTON INSIDE LOGIN MODAL
//      (Make sure Shopify knows user came from Bulk)
//   --------------------------------------------------------- */
//   const loginForm = document.querySelector("#bulkPackagesLoginModal form");
//   if (loginForm) {
//     loginForm.addEventListener("submit", function () {

//       // When login form is submitted, mark that user came from bulk
//       sessionStorage.setItem("from_bulk_packages", "1");
//     });
//   }

//   /* ---------------------------------------------------------
//      LOGIN <-> REGISTER SWITCHING
//   --------------------------------------------------------- */
//   document.getElementById("bulkPackagesGotoRegister")?.addEventListener("click", () => {
//     loginModal.classList.remove("show");
//     registerModal.classList.add("show");
//   });

//   document.getElementById("bulkPackagesGotoLogin")?.addEventListener("click", () => {
//     registerModal.classList.remove("show");
//     loginModal.classList.add("show");
//   });

//   /* ---------------------------------------------------------
//      CLIENT-SIDE REGISTER VALIDATION (PREVENTS REDIRECT)
//   --------------------------------------------------------- */
//  /* ---------------------------------------------------------
//    CLIENT-SIDE REGISTER VALIDATION (PREVENTS REDIRECT)
// --------------------------------------------------------- */
// // const registerForm = document.querySelector("#bulkPackagesRegisterModal form");

// // if (registerForm) {
// //   registerForm.addEventListener("submit", function (e) {

// //     const password = registerForm.querySelector('input[name="customer[password]"]').value;
// //     const email    = registerForm.querySelector('input[name="customer[email]"]').value;
// //     const name     = registerForm.querySelector('input[name="customer[first_name]"]').value;

// //     let errorMessage = "";
// //     let errorBox = registerForm.querySelector(".bulk-packages-error");

// //     // Remove old error box
// //     if (errorBox) errorBox.remove();

// //     // ----------- VALIDATIONS -------------
// //     if (password.length < 5) {
// //       errorMessage = "Password must be at least 5 characters long.";
// //     }

// //     if (errorMessage !== "") {
// //       e.preventDefault(); // STOP SHOPIFY SUBMISSION
// //       e.stopImmediatePropagation(); // EXTRA STOP (IMPORTANT)

// //       // Recreate error UI
// //       errorBox = document.createElement("div");
// //       errorBox.className = "bulk-packages-error";
// //       errorBox.textContent = errorMessage;

// //       registerForm.prepend(errorBox);

// //       // Ensure modal stays open
// //       registerModal.classList.add("show");

// //       return false;
// //     }

// //   });
// // }


//   /* ---------------------------------------------------------
//      AUTO-REOPEN LOGIN MODAL WHEN SHOPIFY RETURNS LOGIN ERROR
//   --------------------------------------------------------- */
//   // if (window.location.search.includes("form_type=customer_login")) {
//   //   loginModal.classList.add("show");
//   // }

//   /* ---------------------------------------------------------
//      AUTO-REOPEN REGISTER MODAL WHEN SHOPIFY RETURNS ERROR
//   --------------------------------------------------------- */
//   // if (window.location.search.includes("form_type=create_customer")) {
//   //   registerModal.classList.add("show");
//   // }

//   /* ---------------------------------------------------------
//      LOGIN SUCCESS HANDLER
//      This happens on /account page (script in theme.liquid)
//   --------------------------------------------------------- */

//   // If Shopify redirected user back to bulk-packages after login success
//   /* ---------------------------------------------------------
//    LOGIN SUCCESS (login_success=1)
//    SHOW CHECKOUT MODAL instead of login modal
// --------------------------------------------------------- */
// // if (window.location.search.includes("login_success=1")) {

// //   // Open checkout modal instead of login modal
// //   //checkoutModal.classList.add("show");

// //   // Clean up URL
// //   setTimeout(() => {
// //     window.history.replaceState({}, document.title, "/pages/bulk-packages");
// //   }, 800);
// // }

// /* ---------------------------------------------------------
//    AUTO-REOPEN REGISTER MODAL WHEN SHOPIFY RETURNS ERRORS
// --------------------------------------------------------- */
// // if (window.location.search.includes("form_type=create_customer")) {
// //     registerModal.classList.add("show");
// // }

//   /* ---------------------------------------------------------
//      REGISTER SUCCESS HANDLER
//   --------------------------------------------------------- */
//   /* ---------------------------------------------------------
//    REGISTER SUCCESS (register_success=1)
// --------------------------------------------------------- */
// /* ---------------------------------------------------------
//    REGISTER SUCCESS → show checkout modal
// --------------------------------------------------------- */
// // if (window.location.search.includes("register_success=1")) {

// //   // Make sure there is no server error showing
// //   if (!document.querySelector("#bulkPackagesRegisterModal .bulk-packages-error")) {

// //     // Open checkout modal instead of register modal
// //     registerModal?.classList.remove("show");
// //     loginModal?.classList.remove("show");

// //     // Show success message inside checkout modal
// //     checkoutModal.classList.add("show");

// //     const success = document.createElement("div");
// //     success.className = "bulk-packages-success";
// //     success.innerHTML = "Account created successfully! Proceed with checkout.";

// //     checkoutModal.querySelector(".bulk-packages-modal-inner").prepend(success);
// //   }
// // }

// /* ---------------------------------------------------------
//    FINAL CHECKOUT BUTTON → ADD + REFRESH DRAWER + OPEN
// --------------------------------------------------------- */
// const finalCheckoutBtn = document.getElementById("bulkPackagesFinalCheckoutBtn");
// const audio = document.getElementById("myAudio");

// // if (finalCheckoutBtn) {
// //   finalCheckoutBtn.addEventListener("click", function () {

// //     if (audio) {
// //       audio.currentTime = 0;
// //       audio.play();
// //     }
// //     checkoutModal?.classList.remove("show");
// //     const confirmPopup = document.getElementById("bulkConfirmPopup");

// //     if (confirmPopup) {
// //       confirmPopup.classList.remove("show");
// //       void confirmPopup.offsetWidth;
// //       confirmPopup.classList.add("show");
// //       setTimeout(() => { confirmPopup.classList.remove("show"); }, 3800);
// //     }


// //     setTimeout(() => {

// //       if (!currentVariant) return;

// //       finalCheckoutBtn.disabled = true;
// //       finalCheckoutBtn.textContent = "Adding…";

// //       fetch("/cart/add.js", {
// //         method: "POST",
// //         headers: {
// //           "Content-Type": "application/json",
// //           "Accept": "application/json"
// //         },
// //         body: JSON.stringify({
// //           id: currentVariant,
// //           quantity: 1
// //         })
// //       })
// //       .then(res => res.json())
// //       .then(() => {

// //         checkoutModal?.classList.remove("show");

// //         const cartDrawer = document.querySelector("cart-drawer-component");

// //         if (cartDrawer) {
// //           console.log("cartDrawer...............",cartDrawer)
// //           cartDrawer.open();


// //           $.ajax({
// //             url: window.location.href,
// //             type: 'GET',

// //             success: function (response) {

// //               const $response = $(response);

// //               // Update cart count
// //               const newCount = $response.find('#cart-drawer-heading').text();
// //               $('#cart-drawer-heading').text(newCount);

// //               // Update subtotal
// //               const newTotal = $response.find('[data-cart-subtotal]').text();
// //               $('[data-cart-subtotal]').text(newTotal);

// //               // update cart-total-pice attr also
// //               // const newTotalAttr = $response
// //               //   .find('.cart__total-value')
// //               //   .attr('cart-total-pice');

// //               // $('.cart__total-value').attr(
// //               //   'cart-total-pice',
// //               //   newTotalAttr
// //               // );

// //               // ===== YOUR CREDIT TOTAL UPDATE =====
// //               if ($('#use-credits-toggle').is(':checked')) {

// //                 let totalPrice = 0;

// //                 document.querySelectorAll(
// //                   '.cart-item-card.credit-price-enabled[data-new-release="true"]'
// //                 ).forEach(function (item) {

// //                   const priceEl = item.querySelector('.regular__price');

// //                   if (!priceEl) return;

// //                   const rawPrice =
// //                     priceEl.getAttribute('item-price') || '0';

// //                   const itemPrice =
// //                     parseFloat(rawPrice.replace(/,/g, '')) || 0;

// //                   totalPrice += itemPrice;
// //                 });

// //                 const totalCart =
// //                   parseFloat(
// //                     (newTotalAttr || '0').replace(/,/g, '')
// //                   ) || 0;

// //                 $('.credit_discount_apply .credit_discount span').html(
// //                   totalPrice.toLocaleString('en-IN', {
// //                     minimumFractionDigits: 2,
// //                     maximumFractionDigits: 2
// //                   })
// //                 );

// //                 $('.credit_discount_apply .total_credit_amount span').html(
// //                   (totalCart - totalPrice).toLocaleString('en-IN', {
// //                     minimumFractionDigits: 2,
// //                     maximumFractionDigits: 2
// //                   })
// //                 );

// //               }

// //               console.log('Cart count & total updated');
// //             },

// //             error: function (xhr, status, error) {
// //               console.log(error);
// //             }
// //           });

// //           // fetch("/cart?section_id=cart-drawer")
// //           //   .then(resp => resp.text())
// //           //   .then(html => {

// //           //     if (typeof cartDrawer.renderContents === "function") {
// //           //       cartDrawer.renderContents(html);
// //           //     }

// //           //     requestAnimationFrame(() => {
// //           //       if (typeof cartDrawer.open === "function") {
// //           //         cartDrawer.open();
// //           //       }
// //           //     });

// //           //     finalCheckoutBtn.disabled = false;
// //           //     finalCheckoutBtn.textContent = "Checkout";
// //           //   });

// //             // fetch("/cart?section_id=cart-drawer")
// //             //   .then(resp => {
// //             //     if (!resp.ok) throw new Error("Cart drawer section not found");
// //             //     return resp.text();
// //             //   })
// //             //   .then(html => {
// //             //     const cartDrawer = document.querySelector("cart-drawer-component");

// //             //     if (cartDrawer && typeof cartDrawer.renderContents === "function") {
// //             //       cartDrawer.renderContents(html);
// //             //     }

// //             //     if (cartDrawer && typeof cartDrawer.open === "function") {
// //             //       cartDrawer.open();
// //             //     }

// //             //     finalCheckoutBtn.disabled = false;
// //             //     finalCheckoutBtn.textContent = "Checkout";
// //             //   });


// //             finalCheckoutBtn.disabled = false;
// //             finalCheckoutBtn.textContent = "Checkout";

// //         }
// //       })
// //       .catch(err => {
// //         console.log("errorrrrrrrrrrrr............ ",err)
// //         console.error(err);
// //         finalCheckoutBtn.disabled = false;
// //         finalCheckoutBtn.textContent = "Checkout";
// //       });

// //     }, 2000); // wait 2 seconds for audio

// //   });
// // }

// //     if (audio) {
// //       audio.currentTime = 0;
// //       audio.play();
// //     }
// //     checkoutModal?.classList.remove("show");
// //     const confirmPopup = document.getElementById("bulkConfirmPopup");

// //     if (confirmPopup) {
// //       confirmPopup.classList.remove("show");
// //       void confirmPopup.offsetWidth;
// //       confirmPopup.classList.add("show");
// //       setTimeout(() => { confirmPopup.classList.remove("show"); }, 3800);
// //     }

// // finalCheckoutBtn.addEventListener("click", function () {
// //   if (finalCheckoutBtn.dataset.loading === "true") return;

// //   if (!currentVariant) return;

// //   finalCheckoutBtn.dataset.loading = "true";
// //   finalCheckoutBtn.disabled = true;
// //   finalCheckoutBtn.textContent = "Adding…";

// //   if (audio) {
// //     audio.currentTime = 0;
// //     audio.play();
// //   }

// //   checkoutModal?.classList.remove("show");

// //   const confirmPopup = document.getElementById("bulkConfirmPopup");
// //   if (confirmPopup) {
// //     confirmPopup.classList.remove("show");
// //     void confirmPopup.offsetWidth;
// //     confirmPopup.classList.add("show");
// //     setTimeout(() => { confirmPopup.classList.remove("show"); }, 3800);
// //   }


// //   setTimeout(() => {
// //     fetch("/cart/add.js", {
// //       method: "POST",
// //       headers: {
// //         "Content-Type": "application/json",
// //         "Accept": "application/json"
// //       },
// //       body: JSON.stringify({
// //         id: currentVariant,
// //         quantity: 1
// //       })
// //     })
// //     .then(res => res.json())
// //     // .then(() => {
// //     //   const cartDrawer = document.querySelector("cart-drawer-component");

// //     //   if (cartDrawer && typeof cartDrawer.open === "function") {
// //     //     cartDrawer.open();
// //     //   } else {
// //     //     window.location.href = "/cart";
// //     //   }
// //     // })
// //     .then(() => {

// //       fetch("/cart.js")
// //         .then(res => res.json())
// //         .then(cart => {

// //             // Total cart quantity
// //             const totalQty = cart.item_count;

// //             // Update all cart count elements
// //             const countEls = document.querySelectorAll(
// //               '#cart-icon-bubble .cart-count-bubble span, .cart-count'
// //             );

// //             countEls.forEach(el => {
// //               el.textContent = totalQty;
// //             });

// //             // Bubble update
// //             const bubble = document.querySelector(".cart-bubble__text-count");

// //             if (bubble) {
// //               // text update
// //               bubble.textContent = totalQty;

// //               // attribute update
// //               bubble.setAttribute("data-unique-count", totalQty);

// //             }

// //           // Subtotal update from cart.js
// //           const currency = Shopify?.currency?.active || 'USD';

// //           const formattedPrice = new Intl.NumberFormat('en-US', {
// //             style: 'currency',
// //             currency: currency
// //           }).format(cart.total_price / 100);

// //           const subtotalEls = document.querySelectorAll('[data-cart-subtotal]');
// //           subtotalEls.forEach(el => {
// //             el.textContent = formattedPrice;
// //           });

// //           // cart__total-value update
// //           $('.cart__total-value')
// //             .attr('cart-total-pice', (cart.total_price / 100).toFixed(2))
// //             .attr('value', formattedPrice)
// //             .text(formattedPrice);

// //           // Open drawer
// //           const cartDrawer = document.querySelector("cart-drawer-component");

// //           if (cartDrawer && typeof cartDrawer.open === "function") {
// //             cartDrawer.open();
// //           } else {
// //             window.location.href = "/cart";
// //           }

// //         });

// //       })
// //     .catch(err => {
// //       console.error(err);
// //     })
// //     .finally(() => {
// //       finalCheckoutBtn.dataset.loading = "false";
// //       finalCheckoutBtn.disabled = false;
// //       finalCheckoutBtn.textContent = "Checkout";
// //     });
// //   }, 2000);
// // });

// // finalCheckoutBtn.addEventListener("click", function () {

// //   // Prevent multiple clicks
// //   if (finalCheckoutBtn.dataset.loading === "true") return;

// //   // Variant check
// //   if (!currentVariant) return;

// //   // Button loading state
// //   finalCheckoutBtn.dataset.loading = "true";
// //   finalCheckoutBtn.disabled = true;
// //   finalCheckoutBtn.textContent = "Redirecting...";

// //   // Play sound
// //   if (audio) {
// //     audio.currentTime = 0;
// //     audio.play();
// //   }

// //   // Close modal
// //   checkoutModal?.classList.remove("show");

// //   // Confirmation popup
// //   const confirmPopup = document.getElementById("bulkConfirmPopup");

// //   if (confirmPopup) {
// //     confirmPopup.classList.remove("show");

// //     // Restart animation
// //     void confirmPopup.offsetWidth;

// //     confirmPopup.classList.add("show");

// //     setTimeout(() => {
// //       confirmPopup.classList.remove("show");
// //     }, 3000);
// //   }

// //   window.location.href = `/cart/${currentVariant}:1?checkout`;

// //   // Delay before checkout
// //   // setTimeout(() => {

// //   //   // Add product to cart
// //   //   fetch("/cart/add.js", {
// //   //     method: "POST",
// //   //     headers: {
// //   //       "Content-Type": "application/json",
// //   //       "Accept": "application/json"
// //   //     },
// //   //     body: JSON.stringify({
// //   //       id: currentVariant,
// //   //       quantity: 1
// //   //     })
// //   //   })
// //   //   .then(res => {

// //   //     if (!res.ok) {
// //   //       throw new Error("Failed to add product");
// //   //     }

// //   //     return res.json();
// //   //   })
// //   //   .then(() => {

// //   //     // Direct checkout redirect
// //   //     window.location.href = "/checkout";

// //   //   })
// //   //   .catch(err => {

// //   //     console.error("Checkout Error:", err);

// //   //     // Reset button on error
// //   //     finalCheckoutBtn.dataset.loading = "false";
// //   //     finalCheckoutBtn.disabled = false;
// //   //     finalCheckoutBtn.textContent = "Checkout";

// //   //   });

// //   // }, 1500);

// // });

// finalCheckoutBtn.addEventListener("click", async function () {

//   // Prevent multiple clicks
//   if (finalCheckoutBtn.dataset.loading === "true") return;

//   // Variant check
//   if (!currentVariant) return;

//   // Button loading state
//   finalCheckoutBtn.dataset.loading = "true";
//   finalCheckoutBtn.disabled = true;
//   finalCheckoutBtn.textContent = "Redirecting...";

//   // Play sound
//   if (audio) {
//     audio.currentTime = 0;
//     audio.play();
//   }

//   // Close modal
//   checkoutModal?.classList.remove("show");

//   // Confirmation popup
//   const confirmPopup = document.getElementById("bulkConfirmPopup");

//   if (confirmPopup) {
//     confirmPopup.classList.remove("show");

//     // Restart animation
//     void confirmPopup.offsetWidth;

//     confirmPopup.classList.add("show");

//     setTimeout(() => {
//       confirmPopup.classList.remove("show");
//     }, 3000);
//   }

//   // try {

//   //   // Save old cart
//   //   const existingCart = await fetch('/cart.js')
//   //     .then(res => res.json());

//   //   console.log("existingCart>>>>>>>>>>>>>>>>>>>",existingCart)

//   //   localStorage.setItem(
//   //     'savedCart',
//   //     JSON.stringify(existingCart.items)
//   //   );

//   //   // Clear cart
//   //   await fetch('/cart/clear.js', {
//   //     method: 'POST'
//   //   });

//   //   // Add single product
//   //   await fetch('/cart/add.js', {
//   //     method: 'POST',
//   //     headers: {
//   //       'Content-Type': 'application/json'
//   //     },
//   //     body: JSON.stringify({
//   //       id: currentVariant,
//   //       quantity: 1
//   //     })
//   //   });

//   //   // Checkout
//   //   // window.location.href = '/checkout';

//   // } catch (err) {

//   //   console.error(err);

//   // }
//   try {

//     const existingCart = await fetch('/cart.js')
//       .then(res => res.json());

//     console.log("Fetched Cart:", existingCart);

//     localStorage.setItem(
//       "savedCart",
//       JSON.stringify(existingCart.items)
//     );

//     // console.log(
//     //   "After Save:",
//     //   localStorage.getItem("savedCart")
//     // );
    
//         // Clear cart
//     await fetch('/cart/clear.js', {
//       method: 'POST'
//     });

//     // Add single product
//     await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify({
//         id: currentVariant,
//         quantity: 1
//       })
//     });

//     // Checkout
//     window.location.href = '/checkout';
    

//   } catch (err) {

//     console.error(err);

//   }

// });

// });


window.preventAutoCartDrawerOpen = true;

document.addEventListener("cart:refresh", function (event) {
  if (window.preventAutoCartDrawerOpen) {
    event.stopImmediatePropagation();
  }
});

document.addEventListener("DOMContentLoaded", function () {

  const checkoutModal = document.getElementById("bulkPackagesCheckoutModal");

  const modalTitle = document.getElementById("bulkPackagesModalProductTitle");
  const modalPrice = document.getElementById("bulkPackagesModalProductPrice");

  const finalCheckoutBtn = document.getElementById("bulkPackagesFinalCheckoutBtn");
  const audio = document.getElementById("myAudio");

  let currentVariant = null;

  /* ---------------------------------------------------------
     OPEN CHECKOUT MODAL
  --------------------------------------------------------- */
  document.querySelectorAll(".bulk-packages-buy-btn").forEach(btn => {

    btn.addEventListener("click", function () {

      const card = this.closest(".bulk-packages-card");

      if (!card) return;

      currentVariant = card.dataset.variantId;

      modalTitle.textContent = card.dataset.title || "";
      modalPrice.textContent = "$" + (card.dataset.price || "0");

      checkoutModal?.classList.add("show");

    });

  });

  /* ---------------------------------------------------------
     CLOSE MODAL
  --------------------------------------------------------- */
  document.querySelectorAll(".bulk-packages-modal-close").forEach(btn => {

    btn.addEventListener("click", function () {

      checkoutModal?.classList.remove("show");

    });

  });

  /* ---------------------------------------------------------
     FINAL CHECKOUT
  --------------------------------------------------------- */
  if (finalCheckoutBtn) {

    finalCheckoutBtn.addEventListener("click", async function () {

      // Prevent multiple clicks
      if (finalCheckoutBtn.dataset.loading === "true") return;

      // Variant check
      if (!currentVariant) return;

      // Button loading state
      finalCheckoutBtn.dataset.loading = "true";
      finalCheckoutBtn.disabled = true;
      finalCheckoutBtn.textContent = "Redirecting...";

      // Play sound
      if (audio) {
        audio.currentTime = 0;
        audio.play();
      }

      // Close modal
      checkoutModal?.classList.remove("show");

      // Confirmation popup
      const confirmPopup = document.getElementById("bulkConfirmPopup");

      if (confirmPopup) {

        confirmPopup.classList.remove("show");

        // Restart animation
        void confirmPopup.offsetWidth;

        confirmPopup.classList.add("show");

        setTimeout(() => {
          confirmPopup.classList.remove("show");
        }, 3000);

      }

      try {

        // Get existing cart
        const existingCart = await fetch("/cart.js")
          .then(res => res.json());

        console.log("Fetched Cart:", existingCart);

        // Save old cart
        localStorage.setItem(
          "savedCart",
          JSON.stringify(existingCart.items)
        );

        // Clear cart
        await fetch("/cart/clear.js", {
          method: "POST"
        });

        // Add selected product
        await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: currentVariant,
            quantity: 1
          })
        });

        // Redirect checkout
        window.location.href = "/checkout";

      } catch (err) {

        console.error("Checkout Error:", err);

        finalCheckoutBtn.dataset.loading = "false";
        finalCheckoutBtn.disabled = false;
        finalCheckoutBtn.textContent = "Checkout";

      }
    });

  }

});
